<script>
import ListDefault from "../../Utils/Page/ListDefault";

export default {
    name: "List",

    mixins: [ListDefault],

    data() {
        return {
            lang: this.$ml.get('pages.blog_post'),

            filter: {
                categories: { value: null, type: 'select', options: [] },
                title: { value: null, type: 'text'},
                is_press: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'title', is_sort: true, classes: 'text-l wrap' },
                { key: 'slug', is_sort: true, classes: 'text-l wrap' },
                { key: 'categories', is_sort: true, classes: 'text-l wrap' },
                { key: 'is_press', is_sort: true, classes: 'text-l' },
                { key: 'visible', is_sort: true, classes: 'text-l' },
            ],
            tableBody: {
                categories: { type: 'function', function: this.getCategory },
                is_press: { type: 'function', function: this.getIsPress },
                visible: { type: 'function', function: this.getVisible },
            },

            apiList: this.$store.getters.getApiUrl('blog_post'),
            pageRoute: 'blog_post',
            pageRouteCreate: 'blog_post.create',
            pageRouteEdit: 'blog_post.edit',
            pagePermission: 'blog.post',
        }
    },

    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    },

    methods: {
        getCategory(item) {
            if (item.categories.length > 0) {
                let names = []
                item.categories.map(category => {
                    names.push(category.title)
                })
                return names.join(', ');
            }
        },
        getIsPress(item) {
            if (item.is_press === null) {
                return '-'
            }
           return this.getBooleanValue(item.is_press)
        },
        getVisible(item) {
            if (item.visible === null) {
                return '-'
            }
           return this.getBooleanValue(item.visible)
        },
    }
}
</script>
